import { createMiddleware, createServerOnlyFn } from "@tanstack/react-start";

// S3Middleware is referenced from server-fn `.middleware([...])` lists, which
// keeps this module in the client bundle — a top-level serverEnv import would
// ship the server env config with it. createServerOnlyFn severs that edge in
// the client build.
const importServerEnv = createServerOnlyFn(() => import("~/lib/server-env"));

declare global {
  var s3: ReturnType<typeof createS3connection> | undefined;
}

export async function createS3connection() {
  const { AwsClient } = await import("aws4fetch");
  const { serverEnv } = await importServerEnv();
  const REGION = serverEnv.AWS_REGION || "us-east-1";
  const S3_BUCKET = serverEnv.S3_BUCKET || "dcm";
  const ENDPOINT = serverEnv.S3_ENDPOINT;
  const S3_PUBLIC_BASE = serverEnv.S3_PUBLIC_BASE;

  return {
    client: new AwsClient({
      region: REGION,
      accessKeyId: serverEnv.S3_ACCESS_KEY_ID!,
      secretAccessKey: serverEnv.S3_SECRET_ACCESS_KEY!,
      service: "s3",
      ...(ENDPOINT && { endpoint: ENDPOINT }),
    }),
    bucket: S3_BUCKET,
    endpoint: ENDPOINT,
    region: REGION,
    publicBase: S3_PUBLIC_BASE,
  };
}

export async function configureS3() {
  if (!globalThis.s3) {
    // Only configure S3 on the server side
    if (typeof process !== "undefined" && process.env) {
      globalThis.s3 = createS3connection();
    } else {
      throw new Error("S3 Bucket can only be configured on the server side");
    }
  }
}

export const S3Middleware = createMiddleware({ type: "function" }).server(
  async ({ next, context: _context }) => {
    try {
      await configureS3();
    } catch (error) {
      console.error("Error configuring S3", error);
    }

    return next();
  },
);
